import {
  FETCH_EDUCATION_REQUEST,
  FETCH_EDUCATION_SUCCESS,
  FETCH_EDUCATION_FAILURE,

  CREATE_EDUCATION_REQUEST,
  CREATE_EDUCATION_SUCCESS,
  CREATE_EDUCATION_FAIL,
  CREATE_EDUCATION_RESET,

  DELETE_EDUCATION_REQUEST,
  DELETE_EDUCATION_SUCCESS,
  DELETE_EDUCATION_FAIL,
  DELETE_EDUCATION_RESET,

  UPDATE_EDUCATION_REQUEST,
  UPDATE_EDUCATION_SUCCESS,
  UPDATE_EDUCATION_FAIL,
  UPDATE_EDUCATION_RESET
} from '../constants/educationConstants';

const initialState = {
  loading: false,
  educations: [],
  error: null

};

export const educationCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_EDUCATION_REQUEST:
      return { loading: true };
    case CREATE_EDUCATION_SUCCESS:
      return { loading: false, success: true };
    case CREATE_EDUCATION_FAIL:
      return { loading: false, error: action.payload };
    case CREATE_EDUCATION_RESET:
      return {};
    default:
      return state;
  }
};

export const educationListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EDUCATION_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_EDUCATION_SUCCESS:
      return { ...state, loading: false, educations: action.payload };
    case FETCH_EDUCATION_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export const educationDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_EDUCATION_REQUEST:
      return { loading: true };
    case DELETE_EDUCATION_SUCCESS:
      return { loading: false, success: true };
    case DELETE_EDUCATION_FAIL:
      return { loading: false, error: action.payload };
    case DELETE_EDUCATION_RESET:
      return {};
    default:
      return state;
  }
};

export const educationUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_EDUCATION_REQUEST:
      return { loading: true };
    case UPDATE_EDUCATION_SUCCESS:
      return { loading: false, success: true };
    case UPDATE_EDUCATION_FAIL:
      return { loading: false, error: action.payload };
    case UPDATE_EDUCATION_RESET:
      return {};
    default:
      return state;
  }
};